var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessPartnerNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 235.69 235.69",
    style: {
      enableBackground: "new 0 0 235.69 235.69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7A7A7A;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4.375;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:3.125;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.875;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:1.4452;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:3.1672;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2.5;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:4.2982;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:2.8804;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:4.6253;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#FFFFFF;stroke-width:5.7817;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:4.6253;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:5.7817;stroke-linecap:round;stroke-linejoin:round;}\r\n\t\r\n\t\t.st15{fill:none;stroke:#FFFFFF;stroke-width:5.7817;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:14.4096,14.4096;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "strzaka"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 68.11,
    cy: 124.91,
    r: 24.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M99.73,225H36.49v-43.9c0-17.46,14.16-31.62,31.62-31.62h0c17.46,0,31.62,14.16,31.62,31.62V225z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M147.06,63.01h7.2c0,0,1.3,7.68,12.89,8.64c0,0-5.79-3.84-4.3-8.64h4.81c2.67,0,4.84-2.17,4.84-4.84V19.84 c0-2.67-2.17-4.84-4.84-4.84h-55.61c-2.67,0-4.84,2.17-4.84,4.84v17.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M147.06,42.4v38.33c0,2.67-2.17,4.84-4.84,4.84h-40.84c0,0-1.3,7.68-12.89,8.64c0,0,5.79-3.84,4.3-8.64 h-6.17c-2.67,0-4.84-2.17-4.84-4.84V42.4c0-2.67,2.17-4.84,4.84-4.84h55.61C144.89,37.56,147.06,39.73,147.06,42.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 89.93,
    y1: 50.04,
    x2: 125.94,
    y2: 50.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 131.22,
    y1: 25.08,
    x2: 167.22,
    y2: 25.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 137.94,
    y1: 31.32,
    x2: 167.22,
    y2: 31.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 117.3,
    y1: 25.08,
    x2: 126.9,
    y2: 25.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 157.62,
    y1: 37.56,
    x2: 167.22,
    y2: 37.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 89.93,
    y1: 74.53,
    x2: 137.94,
    y2: 74.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 89.93,
    y1: 60.13,
    x2: 124.1,
    y2: 60.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 89.93,
    y1: 66.85,
    x2: 124.1,
    y2: 66.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.03,
    y: 149.17,
    className: "st9",
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "64.35,163.81 60.68,187.24 68.74,195.76 76.11,187.24 72.31,163.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.5,
    y: 149.17,
    className: "st9",
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "163.83,163.81 160.15,187.24 168.22,195.76 175.58,187.24 171.79,163.9  "
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 167.58,
    cy: 124.91,
    r: 24.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M199.21,225h-63.25v-43.9c0-17.46,14.16-31.62,31.62-31.62h0c17.46,0,31.62,14.16,31.62,31.62V225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.54,102.74c0,0,4.58,30.46,35.13,22.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M157.63,102.74c0,0,4.58,30.46,35.13,22.18"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPartnerNotification);
export default __webpack_public_path__ + "static/media/Business_Partner_Notification.34e10e0f14d5cc3bb52682e1fbf56988.svg";
export { ForwardRef as ReactComponent };